<template>
	<div class="page">
		<div class="box">
			<pdf-view v-if="pdfUrl" :pdfUrl="pdfUrl" />
		</div>
		<email ref="email" />
		<float-btn :slotState="true" position="right" style="transform: translateX(20px)" @click="postEmail">
			<div class="emailBtn">
				<img src="@/assets/images/email_2.png" />
				<span>发送到邮箱</span>
			</div>
		</float-btn>
	</div>
</template>

<script>
import PdfView from '@/components/PdfPreview.vue';
import FloatBtn from '@/components/FloatBtnH5.vue';
import Email from '@/components/Email.vue';
import { Toast } from 'vant';
export default {
	components: {
		FloatBtn,
		Email,
		PdfView
	},
	data() {
		return {
			pdfUrl: ''
		};
	},
	created() {
		this.$dataStatistics({ event_type: 'view', page_title: `预览PDF` }, ``);
	},
	mounted() {
		this.closeShare();

		this.pdfUrl = decodeURIComponent(this.$route.query?.pdfUrl);
	},
	methods: {
		postEmail() {
			this.$refs.email.id = this.$route.query?.id || ``;
			this.$refs.email.show = true;
		}
	}
};
</script>

<style lang="less" scoped>
.page {
	background-color: #ededef;

	.emailBtn {
		height: 62px;
		background: @themeColor;
		border-radius: 999px 0px 0px 999px;
		padding: 0 18px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 27px;
		color: #ffffff;
		line-height: 1.5;
		box-sizing: content-box;

		span {
			position: relative;
			z-index: 1;
			// transform: translateY(-3px);
		}

		img {
			width: 29px;
			height: 25px;
			display: block;
			margin-right: 13px;
		}
	}

	.box {
		height: 100vh;
	}

	/deep/.backTop {
		bottom: 140px;
	}
}
</style>
